/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React from 'react';
import { useHistory } from 'react-router-dom';

import Button from '../../../components/Button';

import DadosDependente from './Dependente';
import DadosTitular from './Titular';

import { PageContainer, ContainerButton } from '../../../styles/styles';

function DadosBeneficiarios({ location: { dataBeneficiario } }) {
    const history = useHistory();

    return (
        <PageContainer>
            {['dependente', 'agregado'].includes(dataBeneficiario.tipo.toLowerCase()) ? (
                <DadosDependente dados={dataBeneficiario} />
            ) : (
                <DadosTitular dados={dataBeneficiario} />
            )}

            <ContainerButton>
                <Button id="backStep" type="primary" onClick={() => history.goBack()}>
                    Voltar
                </Button>
            </ContainerButton>
        </PageContainer>
    );
}

export default DadosBeneficiarios;
